import { Box } from '@mui/material'
import { FooterProps } from './Footer.types'

export const Footer = ({
  copyrightText,
  privacyText,
  handlePrivacyClick,
  cookiesText,
  handleCookiesClick,
}: FooterProps) => {
  return (
    <Box
      component="footer"
      display="flex"
      justifyContent="center"
      alignItems="center"
      fontSize={14}
      color="primary.main"
      bgcolor="common.white"
      height="60px"
    >
      <Box display="flex">
        <Box mr={1}>&copy; 2009 - {new Date().getFullYear()}.</Box>
        <Box mr={1}>{copyrightText}.</Box>
        <Box>SupplyVue Ltd.</Box>
        <Box
          sx={{ cursor: 'pointer' }}
          ml={2}
          role="link"
          onClick={handlePrivacyClick}
        >
          {privacyText}
        </Box>
        <Box mx={2}>|</Box>
        <Box
          sx={{ cursor: 'pointer' }}
          role="link"
          onClick={handleCookiesClick}
        >
          {cookiesText}
        </Box>
      </Box>
    </Box>
  )
}
